var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { TextFields, Input, Select, Row } from '../../Input';
import { useShipping, shippingValues, defaultRegions, useCartRequiresShipping } from '../Providers';
import { countryRegionsByCode } from '../../../utils/countries';
import { Visible } from '../UI';
export var ShippingInformation = function () {
    var _a = useShipping(), errorText = _a.errorText, showRequired = _a.showRequired;
    var _b = useState(false), showFullAddress = _b[0], setShowFullAddress = _b[1];
    var _c = useState(defaultRegions), regionOptions = _c[0], setRegionOptions = _c[1];
    var requiresShipping = useCartRequiresShipping();
    var handleAddressChange = function () {
        setShowFullAddress(true);
    };
    var handleCountryChange = function (ev) {
        var value = ev.target.value;
        setRegionOptions(countryRegionsByCode[value]);
    };
    if (!requiresShipping)
        return null;
    return (_jsx(_Fragment, { children: _jsxs(TextFields, __assign({ label: "Shipping address", htmlFor: shippingValues.name.props.id, showRequired: showRequired, errorText: errorText }, { children: [_jsx(Input, __assign({}, shippingValues.name.props)), _jsx(Select, __assign({}, shippingValues.country.props, { options: shippingValues.country.options, onChange: handleCountryChange })), _jsx(Input, __assign({}, shippingValues.address.props, { onChange: handleAddressChange })), _jsxs(Visible, __assign({ "$visible": showFullAddress }, { children: [_jsx(Input, __assign({}, shippingValues.address2.props)), _jsxs(Row, { children: [_jsx(Input, __assign({}, shippingValues.city.props)), _jsx(Input, __assign({}, shippingValues.zip.props))] }), _jsx(Select, __assign({}, shippingValues.state.props, { options: regionOptions }))] })), _jsx(Input, __assign({}, shippingValues.phone.props))] })) }));
};
//# sourceMappingURL=Shipping.js.map